module.exports = __webpack_public_path__ + "img/16581265_S.b60194f6.png";